import { render, staticRenderFns } from "./PaymentFormStripeResult.vue?vue&type=template&id=0b079fd8&scoped=true&lang=pug&"
import script from "./PaymentFormStripeResult.vue?vue&type=script&lang=js&"
export * from "./PaymentFormStripeResult.vue?vue&type=script&lang=js&"
import style0 from "./PaymentFormStripeResult.scss?vue&type=style&index=0&id=0b079fd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b079fd8",
  null
  
)

export default component.exports